module.exports = __webpack_public_path__ + "img/banner-1.66da41f6.jpg";